import {
  BackButton,
  MoveBackButton,
} from '@/features/v2/components/buttons/MoveBackButton';
import {
  MoveForwardButton,
  NextButton,
} from '@/features/v2/components/buttons/MoveForwardButton';
import { SubmitStageButton } from '@/features/v2/components/buttons/SubmitStageButton';
import { SubmitStageButtonNew } from '@/features/v2/components/buttons/SubmitStageButtonNew';
import { useStepper } from '@/features/v2/lib/stepper';

export const StepForm = ({
  id,
  onSubmit,
  children,
  nextButton,
  prevButton,
  submitButton,
  isLastStep,
  handleSubmit,
  nextStageOnSubmit,
  newSubmitStage = false,
  backButton,
  withTrigger = false,
  onBackButtonClick,
}: {
  id?: string;
  onSubmit?: (e?: React.BaseSyntheticEvent) => Promise<void>;
  handleSubmit?: () => void;
  children: React.ReactNode;
  nextButton?: NextButton;
  prevButton?: BackButton;
  submitButton?: {
    label: string;
    isDisabledProp?: boolean;
    isLoading?: boolean;
    uniqTestId?: string;
  };
  isLastStep?: boolean;
  nextStageOnSubmit?: boolean;
  newSubmitStage?: boolean;
  backButton: boolean;
  withTrigger?: boolean;
  onBackButtonClick?: () => void;
}) => {
  const { isDeadEnd } = useStepper();
  const showSubmitButton = isLastStep || isDeadEnd;

  return (
    <form onSubmit={onSubmit} id={id}>
      <div className={'mb-5 w-full space-y-5 overflow-hidden'}>{children}</div>
      <div
        className={
          'flex w-full flex-col-reverse items-center gap-x-5 gap-y-4 md:flex-row md:justify-end'
        }
      >
        {backButton && (
          <MoveBackButton
            {...prevButton}
            withTrigger={withTrigger}
            onBackButtonClick={onBackButtonClick}
          />
        )}
        <MoveForwardButton
          hidden={showSubmitButton}
          handleSubmit={handleSubmit}
          {...nextButton}
        />
        {!newSubmitStage && (
          <SubmitStageButton
            hidden={!showSubmitButton}
            nextStageOnSubmit={nextStageOnSubmit}
            {...submitButton}
          />
        )}
        {newSubmitStage && (
          <SubmitStageButtonNew
            hidden={!showSubmitButton}
            uniqTestId={submitButton?.uniqTestId}
            nextStageOnSubmit={nextStageOnSubmit}
            {...submitButton}
          />
        )}
      </div>
    </form>
  );
};
